import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ButtonGroup} from '../../../../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroup';
import {VisualSizesEnum} from '../../../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface InviteDropdownInviteFooterProps {
  isInviteEnabled: boolean;
  onCancelClick: Handler;
  onInviteClick: Handler;
  hasComment: boolean;
}

/*
 * Style.
 */

const StyledFooterDiv = styled.div`
  display: flex;
  align-items: center;

  padding: 0 12px;
  border-top: 1px solid ${(p) => p.theme.greys.shade30};
`;

const StyledLabelDiv = styled.div`
  flex: 1;
  color: ${(p) => p.theme.greys.shade60};
  font-size: ${fontSizes.tiny};
  line-height: 15px;
`;

const StyledButtonsDiv = styled.div`
  flex-shrink: 0;
  margin: 12px 0 12px 20px;
`;

/*
 * Component.
 */

export const InviteDropdownInviteFooter: FC<InviteDropdownInviteFooterProps> = (props) => (
  <StyledFooterDiv>
    <StyledLabelDiv>
      {props.hasComment && (
        <Trans id="invite-footer-comment">This comment will be sent in the conversation.</Trans>
      )}
    </StyledLabelDiv>
    <StyledButtonsDiv>
      <ButtonGroup>
        <Button
          size={VisualSizesEnum.SMALL}
          variant={ButtonVariantsEnum.SECONDARY}
          onClick={props.onCancelClick}
        >
          <Trans id="invite-footer-cancel">Cancel</Trans>
        </Button>
        <Button
          size={VisualSizesEnum.SMALL}
          variant={ButtonVariantsEnum.PRIMARY}
          onClick={props.onInviteClick}
          isDisabled={!props.isInviteEnabled}
        >
          <Trans id="invite-footer-add">Add</Trans>
        </Button>
      </ButtonGroup>
    </StyledButtonsDiv>
  </StyledFooterDiv>
);
